import { useMemoFormContext } from '../context/FormContext';
import { createEmptyTask, MemoType } from 'models/Memo';

// Switches the composer to another memo type.
//
// Content, title, description, source, author and tasks are shared fields
// whose meaning depends on the type (content is body text for Text but a URL
// for Link), so switching type starts that type fresh. The collection isn't
// type specific, so it stays. Picking the current type again changes nothing.
export function useSwitchMemoType() {
  const { setValue, selectedMemoType } = useMemoFormContext();

  return (memoType: MemoType) => {
    if (memoType === selectedMemoType) {
      return;
    }

    setValue('type', memoType);
    setValue('content', '');
    setValue('title', '');
    setValue('description', '');
    setValue('source', '');
    setValue('author', '');
    setValue('tasks', [createEmptyTask()]);
  };
}
